import styled from "styled-components";
import { colorWhiteBase } from "@mediahuis/chameleon-theme-wl";
var SuggestionWrapper = styled.ul.withConfig({
  displayName: "SuggestionWrapper",
  componentId: "sc-1gx99t-0"
})(["position:absolute;bottom:0;left:0;right:0;max-height:138px;overflow-y:scroll;transform:translateY(100%);background-color:", ";z-index:100;box-shadow:0 2px 4px 0 rgba(0,0,0,0.31);"], colorWhiteBase);
export default SuggestionWrapper;